import {
  InternalTransferMethodEnum,
  InternalTransferTypeEnum,
} from '@interfaces/internal-transfer/internal-transfer.interface';
import {
  AccountTypes,
  CurrentInputAccount,
  ISelectedAccount,
  TransactionTypesEnum,
} from '@interfaces/models';
import { AvgCostConversion, MinTaxConversion } from '@interfaces/models/spec-id-fallback.enum';

export interface InternalTransferTriage {
  transferFrom: AccountTypes;
  transferTo: AccountTypes;
  isOwner: boolean;
  exceptionsApply: boolean;
  isTransferConditionsAffirmed?: boolean;
  isDivorceTransfer?: boolean | null;
  isGift?: boolean | null;
}

export interface InternalTransferFrom {
  selectedAccount: ISelectedAccount;
  transferType: InternalTransferTypeEnum;
  transferMethod: InternalTransferMethodEnum;
  totalTransferValue?: string;
  convertSpecIDHoldings: boolean;
  convertAvgCostHoldings: boolean;
  hasAvgCostHoldings: boolean;
  percentageOfHoldings: string;
  avgCostConversion: AvgCostConversion;
  minTaxConversion: MinTaxConversion;
  transferAllSelected: boolean;
}
export interface InternalTransferTo {
  selectedAccount: CurrentInputAccount;
}
export interface InternalTransferState {
  triage: InternalTransferTriage;
  transferFrom: InternalTransferFrom;
  transferTo: InternalTransferTo;
  transactionType: TransactionTypesEnum;
  transferId?: string;
  signerState?: string;
}
